import { Link } from "react-router-dom";

/**
 * Faitharama logo — green FAITH + orange ARAMA + .COM, with a cross above.
 * Renders pure CSS/SVG so it scales crisply at every size and never depends
 * on an external image (no broken-link risk).
 *
 * Color tokens (matched to Mike's brand artwork):
 *   • Green:  #2E9F3A  (FAITH)
 *   • Orange: #F39A1F  (ARAMA + .COM + underline)
 *   • Cross:  same orange
 *
 * Sizes: sm (nav) · md (footer) · lg (hero) · xl (giant hero plaque)
 */

const C_GREEN = "#2E9F3A";
const C_ORANGE = "#F39A1F";

const SIZES = {
  sm: { word: "text-2xl md:text-3xl", dot: "text-[10px] tracking-[0.5em]",  cross: 14, gap: "mt-0"   },
  md: { word: "text-3xl md:text-4xl", dot: "text-[11px] tracking-[0.55em]", cross: 18, gap: "mt-0.5" },
  lg: { word: "text-5xl md:text-6xl", dot: "text-[13px] tracking-[0.6em]",  cross: 28, gap: "mt-1"   },
  xl: { word: "text-6xl md:text-7xl", dot: "text-[15px] tracking-[0.65em]", cross: 36, gap: "mt-1.5" },
};

function Cross({ size }) {
  // Simple orange cross sitting above the wordmark
  const w = size;
  const h = Math.round(size * 1.45);
  return (
    <svg width={w} height={h} viewBox="0 0 20 30" aria-hidden="true" style={{ marginBottom: 2 }}>
      <rect x="9"  y="0"  width="2.2"  height="30" fill={C_ORANGE} rx="1"/>
      <rect x="3"  y="9"  width="14"   height="2.2" fill={C_ORANGE} rx="1"/>
    </svg>
  );
}

export default function LogoText({ size = "sm", to = "/", as = "link", className = "", subline = false }) {
  const s = SIZES[size] || SIZES.sm;
  const inner = (
    <span className={`inline-flex flex-col items-center leading-none select-none ${className}`} data-testid="brand-logo">
      <Cross size={s.cross}/>
      <span className="font-serif-display whitespace-nowrap" style={{ letterSpacing: "0.02em", lineHeight: 1 }}>
        <span className={s.word} style={{ color: C_GREEN, fontWeight: 800 }}>FAITH</span>
        <span className={s.word} style={{ color: C_ORANGE, fontWeight: 800 }}>ARAMA</span>
      </span>
      <span className={`${s.dot} ${s.gap} font-overline uppercase font-bold`} style={{ color: C_ORANGE }}>.COM</span>
      {subline && (
        <span className="text-[10px] tracking-wider-cap text-foreground mt-1.5">Faith &amp; Wellness</span>
      )}
    </span>
  );
  if (as === "link") return <Link to={to} className="inline-block">{inner}</Link>;
  return inner;
}
